import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BtxSharedModule } from '../../shared/btx-shared.module';
import { CompleteExpertComponent } from './complete-expert.component';

@NgModule({
  declarations: [CompleteExpertComponent],
  imports: [BtxSharedModule, RouterModule, CommonModule],
  exports: [CompleteExpertComponent],
})
export class CompleteExpertModule {}
